import { render } from "./GeolocationLookupLog.vue?vue&type=template&id=aef19868&scoped=true"
import script from "./GeolocationLookupLog.vue?vue&type=script&lang=js"
export * from "./GeolocationLookupLog.vue?vue&type=script&lang=js"

import "./GeolocationLookupLog.vue?vue&type=style&index=0&id=aef19868&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/342/dashboard.jumpfeed.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef19868"]])

export default __exports__